export const locale = {
    lang: 'it',
    data: {
        'SAMPLE': {
            'HELLO': 'In costruzione'
        }
    }
};
